import { render, staticRenderFns } from "./ModalReorderRequest.vue?vue&type=template&id=c99ea8fe&"
import script from "./ModalReorderRequest.vue?vue&type=script&lang=js&"
export * from "./ModalReorderRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports